export default __webpack_public_path__ + "static/media/portfolio-hover-200.0f0da5ac.jpg";